var _a, _b;
import React, { useState, useRef, useEffect } from 'react';
import { apiHolder, apis } from 'api';
import { Radio, Input, Divider, Checkbox, Button, message } from 'antd';
import classnames from 'classnames';
import SiriusMessage from '@web-common/components/UI/Message/SiriusMessage';
import Alert from '@web-common/components/UI/Alert/Alert';
import { downloadFile } from '@web-common/components/util/file';
import IconCard from '@web-common/components/UI/IconCard';
import MoreOutlined from '@ant-design/icons/MoreOutlined';
import SwapRightOutlined from '@ant-design/icons/SwapRightOutlined';
import styles from './feedbackContent.module.scss';
import { LagBasicContent, LagCollectionContent } from './lagBasicContent';
import { getIn18Text } from 'api';
import { emailPattern } from '@web-common/utils/constant';
const default_no_email = 'nologinaccount@office.163.com';
const loggerApi = apiHolder.api.requireLogicalApi(apis.loggerApiImpl);
const fileApi = apiHolder.api.getFileApi();
const eventApi = apiHolder.api.getEventApi();
const systemApi = apiHolder.api.getSystemApi();
const inElectron = systemApi.isElectron();
const isMac = inElectron && ((_b = (_a = window.electronLib) === null || _a === void 0 ? void 0 : _a.env) === null || _b === void 0 ? void 0 : _b.isMac);
const platform = inElectron ? (isMac ? 'mac' : 'win') : 'web';
const feedbackApi = apiHolder.api.requireLogicalApi(apis.feedbackApiImpl);
const { TextArea } = Input;
const FeedbackContent = props => {
    const { cancel, feedbackType = 'all' } = props;
    const isLoginType = feedbackType === 'login';
    const [module, setModule] = useState(isLoginType ? 'login' : 'mail');
    const [desc, setDesc] = useState('');
    const [descErr, setDescErr] = useState(false);
    const [logFlag, setLogFlag] = useState(true);
    const [submiting, setSubmiting] = useState(false);
    const [graphicList, setGraphicList] = useState([]);
    const [inputEmail, setInputEmail] = useState('');
    const inputRef = useRef(null);
    const init = () => {
        setModule('mail');
        setDesc('');
        setDescErr(false);
        setLogFlag(true);
        setSubmiting(false);
        setGraphicList([]);
    };
    const upload = async (file, fileName, type) => {
        var _a;
        const formatType = (_a = file.type) === null || _a === void 0 ? void 0 : _a.split('/')[1];
        const res = await loggerApi.uploadNosMediaOrLog(file, fileName, type, isLoginType);
        if (res === 'success') {
            type !== 'log' && SiriusMessage.success({ content: getIn18Text('SHANGCHUANCHENGGONG') });
        }
        else {
            SiriusMessage.error({ content: getIn18Text('SHANGCHUANSHIBAI') });
        }
        return res;
    };
    const inputChange = async () => {
        var _a, _b, _c, _d;
        const files = (_a = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === null || _a === void 0 ? void 0 : _a.files;
        const userEmail = ((_b = systemApi.getCurrentUser()) === null || _b === void 0 ? void 0 : _b.id) || default_no_email;
        if (files && files[0]) {
            const maxSize = 500 * 1024 * 1024;
            if (files[0].size > maxSize) {
                SiriusMessage.warn({ content: getIn18Text('WENJIANZUIDAZHI') });
                return;
            }
            const url = URL.createObjectURL(files[0]);
            const fileType = (_c = files[0].type) === null || _c === void 0 ? void 0 : _c.split('/')[0];
            const fileNameArr = ((_d = files[0].name) === null || _d === void 0 ? void 0 : _d.split('.')) || [];
            const formatType = fileNameArr.reverse()[0] || '';
            const type = ['image', 'video'].includes(fileType) ? fileType : 'file';
            const fileName = `clieng-log/sirius/${platform}/${userEmail}/${Date.now()}-0.${formatType}`;
            const ingGraphic = [
                {
                    url,
                    type,
                    formatType,
                    status: 'uploading',
                    name: fileName,
                    fileCreateTime: Date.now(),
                    size: files[0].size,
                },
            ];
            const prevGraphicList = [...graphicList];
            setGraphicList([...prevGraphicList, ...ingGraphic]);
            const uploadRes = await upload(files[0], fileName, formatType);
            if (uploadRes === 'success') {
                const sucGraphic = [
                    Object.assign(Object.assign({}, ingGraphic[0]), { status: 'success' }),
                ];
                setGraphicList([...prevGraphicList, ...sucGraphic]);
            }
            else {
                setGraphicList(prevGraphicList);
            }
        }
    };
    const handleCancel = () => {
        init();
        if (inElectron && !isLoginType) {
            systemApi.closeWindow();
        }
        cancel && cancel();
    };
    const saveLogs = async () => {
        var _a, _b;
        if (inElectron) {
            const res = await ((_b = (_a = window.electronLib) === null || _a === void 0 ? void 0 : _a.fsManage) === null || _b === void 0 ? void 0 : _b.logsToArrayBuf());
            const { success, name, path } = res;
            if (success) {
                fileApi.downloadLocalFile({
                    fileName: name,
                    filePath: path,
                });
            }
            else {
                SiriusMessage.error({ content: getIn18Text('BAOCUNSHIBAI') });
            }
        }
        else {
            const logBlobArray = await loggerApi.getWebLogs();
            if (!logBlobArray || !logBlobArray.size) {
                return;
            }
            [...logBlobArray.keys()].forEach(item => {
                const logFile = new File([logBlobArray.get(item)], `${item}.log`);
                downloadFile(logFile, 'log.log');
            });
        }
    };
    const handleSubmit = async (flag = false) => {
        var _a, _b, _c;
        setSubmiting(true);
        const deviceInfo = await systemApi.getDeviceInfo();
        const userEmail = (_a = systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id;
        let _desc = '';
        if (module === 'hang') {
            _desc = getIn18Text('KADUNFANKUI：') + lagBasicContentRef.current.getContent() + JSON.stringify(lagCollectionContentRef.current.getContent().content);
        }
        else {
            _desc = desc;
        }
        const params = {
            email: userEmail || inputEmail || default_no_email,
            productId: deviceInfo.p === 'web' ? 'sirius' : deviceInfo.p,
            deviceId: '',
            platform,
            version: window.siriusVersion,
            systemVersion: deviceInfo._systemVersion || '',
            module,
            description: _desc,
            files: graphicList.map((item) => {
                const { type, name, fileCreateTime, size } = item;
                return {
                    type,
                    name,
                    fileCreateTime,
                    size,
                };
            }),
        };
        if (logFlag || flag) {
            let fileName = `clieng-log/sirius/${platform}/${userEmail}/${Date.now()}-0`;
            const logFileMap = new Map();
            if (inElectron) {
                const electronRes = await ((_c = (_b = window.electronLib) === null || _b === void 0 ? void 0 : _b.fsManage) === null || _c === void 0 ? void 0 : _c.logsToArrayBuf());
                fileName = `${fileName}.zip`;
                logFileMap.set(fileName, new File([electronRes === null || electronRes === void 0 ? void 0 : electronRes.data], fileName, { type: 'application/zip' }));
            }
            else {
                const logBlobArray = await loggerApi.getWebLogs();
                [...logBlobArray.keys()].forEach(logName => {
                    logFileMap.set(`${fileName}.${logName}.log`, new File([logBlobArray.get(logName)], `${fileName}.${logName}.log`));
                });
            }
            const uploadRes = await Promise.all([...logFileMap.keys()].map(_fileName => upload(logFileMap.get(_fileName), _fileName, 'log')));
            const suc = new Set(uploadRes).size === 1 && uploadRes.includes('success');
            if (suc) {
                [...logFileMap.keys()].forEach(_fileName => {
                    const singleFile = logFileMap.get(_fileName);
                    params.files.push({
                        type: 'log',
                        name: _fileName,
                        fileCreateTime: Date.now(),
                        size: singleFile.size,
                    });
                });
            }
            else {
                setSubmiting(false);
                SiriusMessage.error(getIn18Text('RIZHISHANGCHUANSHI'));
                return;
            }
        }
        const feedbackRes = isLoginType ? await feedbackApi.submitFeedbackNoLogin(params) : await feedbackApi.submitFeedback(params);
        if (feedbackRes.success) {
            setSubmiting(false);
            SiriusMessage.success(getIn18Text('GANXIENINDEFAN')).then(r => {
                handleCancel();
            });
        }
        else {
            setSubmiting(false);
            SiriusMessage.error(getIn18Text('TIJIAOSHIBAI'));
        }
    };
    const beforeSubmit = () => {
        var _a, _b;
        if (!desc.trim() && module !== 'hang') {
            setDesc('');
            setDescErr(true);
            return;
        }
        if (isLoginType && (!inputEmail || !inputEmail.length || !emailPattern.test(inputEmail))) {
            return SiriusMessage.error(getIn18Text('YOUXIANGGESHICUO'));
            return;
        }
        if (module === 'hang' && ((_b = (_a = lagCollectionContentRef.current) === null || _a === void 0 ? void 0 : _a.getContent()) === null || _b === void 0 ? void 0 : _b.status) === 'ing') {
            message.info(getIn18Text('QINGDENGDAICAIJIWANCHENG'));
            return;
        }
        if (graphicList.some(item => item.status === 'uploading')) {
            SiriusMessage.info({ content: getIn18Text('WENJIANSHANGCHUANZHONG11') });
            return;
        }
        if (!logFlag) {
            const al = Alert.error({
                title: getIn18Text('NINWEITONGYIFA'),
                content: getIn18Text('FASONGRIZHIXIN1'),
                funcBtns: [
                    {
                        text: getIn18Text('BULE\uFF0CZHIJIE'),
                        onClick: () => {
                            handleSubmit();
                            al.destroy();
                        },
                    },
                    {
                        text: getIn18Text('TIJIAOBINGFASONG'),
                        type: 'primary',
                        onClick: () => {
                            setLogFlag(true);
                            handleSubmit(true);
                            al.destroy();
                        },
                    },
                ],
            });
        }
        else {
            handleSubmit();
        }
    };
    const uploadGraphic = () => {
        var _a;
        (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.click();
    };
    const deleteGraphic = (index) => {
        const nextGraphicList = [...graphicList];
        nextGraphicList.splice(index, 1);
        setGraphicList(nextGraphicList);
    };
    useEffect(() => {
        const eid = eventApi.registerSysEventObserver('electronClose', { func: () => init() });
        return () => {
            eventApi.unregisterSysEventObserver('electronClose', eid);
        };
    }, []);
    const lagBasicContentRef = useRef({
        getContent() {
            return '';
        },
    });
    const lagCollectionContentRef = useRef({
        getContent() {
            return { status: '', content: '' };
        },
    });
    return (React.createElement("div", { className: classnames(styles.feedbackContent, inElectron && !isLoginType ? styles.feedbackContentApp : '') },
        React.createElement("p", { className: styles.feedbackContentTitle }, getIn18Text('WENTIFANKUI')),
        React.createElement("div", { className: styles.feedbackContentModule },
            React.createElement("p", { className: styles.feedbackContentSubTitle },
                React.createElement("span", { className: styles.feedbackContentRequired }, "* "),
                getIn18Text('GONGNENGMOKUAI\uFF1A')),
            React.createElement(Radio.Group, { buttonStyle: "outline", onChange: e => setModule(e.target.value), value: module }, isLoginType ? (React.createElement(Radio, { value: "login" }, getIn18Text('DENGLU'))) : (React.createElement(React.Fragment, null,
                React.createElement(Radio, { value: "mail" }, getIn18Text('YOUXIANG')),
                React.createElement(Radio, { value: "im" }, getIn18Text('XIAOXI')),
                React.createElement(Radio, { value: "schedule" }, getIn18Text('RILI')),
                React.createElement(Radio, { value: "cdoc" }, getIn18Text('YUNWENDANG')),
                React.createElement(Radio, { value: "contact" }, getIn18Text('TONGXUNLU')),
                React.createElement(Radio, { value: "hang" }, getIn18Text('KADUN')),
                React.createElement(Radio, { value: "other" }, getIn18Text('QITA')))))),
        isLoginType ? (React.createElement("div", { className: styles.feedbackContentModule },
            React.createElement("p", { className: styles.feedbackContentSubTitle },
                React.createElement("span", { className: styles.feedbackContentRequired }, "* "),
                getIn18Text('FEEDBACKEMAIL')),
            React.createElement(Input, { style: { width: '360px' }, spellCheck: "false", placeholder: getIn18Text('QINGSHURUYOUXIANG'), value: inputEmail, onChange: e => {
                    setInputEmail(e.target.value);
                }, autoComplete: "off", suffix: React.createElement("span", null) }))) : null,
        module !== 'hang' ? (React.createElement("div", { className: styles.feedbackContentDesc },
            React.createElement("p", { className: styles.feedbackContentSubTitle },
                React.createElement("span", { className: styles.feedbackContentRequired }, "* "),
                getIn18Text('WENTIMIAOSHU\uFF1A')),
            React.createElement(TextArea, { placeholder: isLoginType ? getIn18Text('LOGINQINGXIANGXIMIAOSHU') : getIn18Text('QINGXIANGXIMIAOSHU'), value: desc, showCount: true, maxLength: 1000, onChange: e => {
                    setDescErr(false);
                    setDesc(e.target.value);
                } }),
            descErr && React.createElement("p", { className: styles.feedbackContentErr }, getIn18Text('QINGXIANGXIMIAOSHU')))) : null,
        module === 'hang' ? (React.createElement(React.Fragment, null,
            React.createElement("div", null,
                React.createElement("p", { className: styles.feedbackContentSubTitle },
                    React.createElement("span", { className: styles.feedbackContentRequired }, "* "),
                    React.createElement("b", null, getIn18Text('WENTIMIAOSHU'))),
                React.createElement(LagBasicContent, { ref: lagBasicContentRef })),
            React.createElement("div", null,
                React.createElement("p", { className: styles.feedbackContentSubTitle },
                    React.createElement("span", { className: styles.feedbackContentRequired }, "* "),
                    React.createElement("b", null, getIn18Text('CAIJIKADUNXINXI'))),
                React.createElement(LagCollectionContent, { ref: lagCollectionContentRef })))) : null,
        React.createElement("div", { className: styles.feedbackContentGraphic },
            React.createElement("p", { className: styles.feedbackContentSubTitle }, getIn18Text('SHANGCHUANXIANGGUANFU')),
            module === 'hang' ? (React.createElement(React.Fragment, null,
                platform === 'web' ? (React.createElement("p", { className: styles.feedbackNote },
                    getIn18Text('WEILEGENGJINGZHUNKUAISU'),
                    React.createElement(MoreOutlined, null),
                    React.createElement(SwapRightOutlined, null),
                    getIn18Text('GENGDUOGONGJU'),
                    React.createElement(SwapRightOutlined, null),
                    getIn18Text('RENWUGUANLIQI'))) : null,
                platform === 'mac' ? React.createElement("p", { className: styles.feedbackNote }, getIn18Text('WEILEGENGJINGZHUNKUAISU')) : null,
                platform === 'win' ? React.createElement("p", { className: styles.feedbackNote }, getIn18Text('WEILEGENGJINGZHUNKUAISU')) : null)) : null,
            React.createElement("div", { className: styles.feedbackContentUpload },
                React.createElement("div", { className: styles.feedbackContentUploadItems },
                    graphicList.map((item, index) => (React.createElement("div", { className: styles.feedbackContentUploadItem },
                        React.createElement("div", { className: styles.feedbackContentUploadGraphic },
                            React.createElement(IconCard, { type: item.formatType }),
                            item.status === 'uploading' && React.createElement("div", { className: styles.feedbackContentUploadIng })),
                        item.status !== 'uploading' && React.createElement("div", { className: styles.feedbackContentUploadDelete, onClick: () => deleteGraphic(index) })))),
                    !graphicList.some(item => item.status === 'uploading') && graphicList.length < 5 && (React.createElement("div", { className: styles.feedbackContentUploadIcon, onClick: () => uploadGraphic() })),
                    React.createElement("input", { ref: inputRef, type: "file", accept: "*/*", className: styles.feedbackContentUploadInput, onClick: e => {
                            e.target.value = '';
                        }, onChange: inputChange })),
                React.createElement("span", { className: styles.feedbackContentUploadCount },
                    graphicList.length,
                    "/5"))),
        React.createElement("div", { className: styles.feedbackContentFoot },
            React.createElement(Divider, null),
            React.createElement("div", { className: styles.feedbackContentChoose },
                React.createElement(Checkbox, { checked: logFlag, className: styles.feedbackContentCheck, onChange: e => setLogFlag(e.target.checked) }, getIn18Text('FASONGRIZHIXIN')),
                React.createElement("span", { className: styles.feedbackContentSave, onClick: () => saveLogs() }, getIn18Text('DIANJIBAOCUNRI')),
                React.createElement("div", { className: styles.feedbackContentBtns },
                    React.createElement(Button, { onClick: () => handleCancel() }, getIn18Text('QUXIAO')),
                    React.createElement(Button, { onClick: () => beforeSubmit(), loading: submiting, type: "primary" }, getIn18Text('TIJIAO')))))));
};
export default FeedbackContent;
